<template>

	<div class="topicDetail">

		<div class="breadcrumb">话题管理 > 查看详情
			<el-button class="right_f" type="primary" @click="back">返回</el-button>
			<el-button class="right_f" type="primary" @click="noIssue">撤销发布</el-button>
		</div>

		<div class="topicNum">
			<div class="commentNum">评论数：{{topicForm.commentNum}}</div>
			<div class="participateNum">参与人：{{topicForm.participateNum}}</div>
		</div>

		<div class="detail">

			<el-form ref="articleForm" :model="topicForm" label-width="100px">

				<el-form-item label="封面图片">
					<img style="width: 325px; height: 125px;" :src="topicForm.coverUrl" alt="">
				</el-form-item>

				<el-form-item label="详情页图片">
					<img style="width: 325px; height: 125px;" :src="topicForm.detailUrl" alt="">
				</el-form-item>

				<el-form-item label="话题名称" class="topicTitle">
					<el-input v-model="topicForm.title" disabled></el-input>
				</el-form-item>

				<el-form-item label="摘要" class="topicAbstract">
					<el-input type="textarea" :autosize="{minRows:3,maxRows:5}" v-model="topicForm.abstract" disabled></el-input>
				</el-form-item>

				<el-form-item label="类别" class="articleType">
					<el-input v-model="topicForm.type" disabled></el-input>
				</el-form-item>

				<el-form-item label="初始参与数" class="initParticipateNum">
					<el-input v-model="topicForm.initParticipateNum" disabled></el-input>
				</el-form-item>

				<el-form-item>
					<el-checkbox class="radio" v-model="topicForm.ifNotice" disabled>首次发布，向所有用户发送更新通知</el-checkbox>
				</el-form-item>

				<select-school :schObj="topicForm.schObj" :canUse="canUse"></select-school>
			</el-form>
		</div>
	</div>
</template>
<script>
	import selectSchool from "../../common/selectSch.vue"

	export default {
		data() {
			return {
				topicId: 1,
				canUse: false,
				topicForm: {
					schObj: {}
				},
				domain: ''
			}
		},
		components: { selectSchool },
		mounted() {
			this.getTopic();
		},
		methods: {
			back() {
				history.go(-1);
			},

			getTopic() {
				let url = window.location.href

				if (url.indexOf('?') !== -1) {
					this.topicId = this.$util.getUrlParam('topicId');
					this.getDetail(this.topicId);
				};
			},

			getDetail(id) {

				//请求数据
				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v2/operate/topic/detail',
					body: JSON.stringify({ id })
				}).then(responseData => {
					let response = responseData.data.data;
					let ifNotice = (response.publishNum === 0) ? false : true;

					this.topicForm = {
						ifNotice,
						coverUrl: response.coverImage,
						detailUrl: response.detailImage,
						title: response.title,
						initParticipateNum: response.initParticipateNum,
						abstract: response.summary,
						type: response.category,
						schObj: {
							shieldedSchools: [],
							openedSchools: [],
							applicableCampus: response.applicableCampus ? response.applicableCampus + "" : "0"
						},
						commentNum: response.commentCount,
						participateNum: response.participateCount
					}

					response.applicableCampus == 0 ? (this.topicForm.schObj.shieldedSchools = response.campusList) : (this.topicForm.schObj.openedSchools = response.campusList);

				})

			},

			changeStatus(newStatus) {

				this.$http({
					method: 'POST',
					url: this.$util.domain + '/adminapi/v2/operate/topic/change_status',
					body: JSON.stringify({
						newStatus,
						id: this.topicId,
					})
				}).then(response => {

					if (response.data.error === 10000) {
						location.href = '/#/yunying/topic/topicManage';
					}

				})
			},

			noIssue() {
				this.$confirm('确定要撤销发布吗？撤销发布后该话题会变成“已撤销”状态，且用户端将无法看到该话题', '撤销发布', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					this.changeStatus(9);

				}).catch(() => {
					//do nothing
				})
			}

		}
	}
</script>
<style>
	.topicNum {
		position: absolute;
		top: 100px;
		right: 100px;
	}

	.gray {
		color: #999;
	}
</style>


// WEBPACK FOOTER //
// topicDetail.vue?7925e396